import axios from 'axios';
import config from '../config';
import { getCookie } from '../helpers';

// create axios instance
let instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

// set auth token for any request
instance.interceptors.request.use(function (config) {
  if (getCookie('access_token').trim() != '') {
    config.headers['Authorization'] = `Token ${getCookie('access_token')}`;
  }
  return config;
});

function path(route) {
  return `${config.baseUrl}/analytics/${route}`;
}

export default class AnalyticsService {
  async postAnalytics(data) {
    try {
      const response = await instance.post(path(''), data, {
        withCredentials: true,
      });
      return response.data;
    } catch (e) {
      return new Error('analyticsService.js:postAnalytics:: ' + e.message);
    }
  }

  async postAnalyticsEvent(data) {
    try {
      const response = await instance.post(path('events'), data, {
        withCredentials: true,
      });
      return response.data;
    } catch (e) {
      return new Error('analyticsService.js:postAnalyticsEvent:: ' + e.message);
    }
  }
}
